import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import { MainNavBar } from '../mainNavBar/MainNavBar';
import {SECTION_811, SECTION_NEI, SECTION_UNDERGROUND_INFRASTRUCTURE} from '../../constants';

import sectionNeiImageUrl from './assets/nei_page_hero_2x.jpg';
import sectionUndergroundInfrastructureImageUrl from './assets/infra_hero_2x.jpg';
import section811ImageUrl from './assets/811_hero_alt_2x.jpg';
import logo from './assets/nei_logo_2x.png';
import playButton from './assets/playButton.png';

// import * as routePaths from '../../routePaths';

import './header.scss';

/**
 * The MainNavBar component.
 */
export class Header extends React.Component {
  /**
   * @constructor
   * @param {{}} props
   * @param {{}} componentContext
   */
  constructor(props, componentContext) {
    super(props, componentContext);
    this.playVideo = this.playVideo.bind(this);
  }

  playVideo() {
    /*if(!this.state.videoIsPlaying){
      this.refs.vidRef.play();
      this.setState({'videoIsPlaying':true});
    }
    else{
      this.refs.vidRef.pause();
      this.setState({'videoIsPlaying':false});
    }*/

    this.refs.modalBtn.click();

  }
  /**
   * Renders the component.
   *
   * @returns {{}}
   */
  render() {
    let imageUrl;
    switch (this.props.section) {
      case SECTION_NEI:
        imageUrl = sectionNeiImageUrl;
        break;
      case SECTION_UNDERGROUND_INFRASTRUCTURE:
        imageUrl = sectionUndergroundInfrastructureImageUrl;
        break;
      case SECTION_811:
        imageUrl = section811ImageUrl;
        break;
      default:
        imageUrl = sectionUndergroundInfrastructureImageUrl;
    }
    return (
      <div id="header">
        <div className="hero-slider" style={{backgroundImage: `url(${imageUrl})`}}>
          <img className="header-logo" src={logo} alt="Header Logo" />
          <MainNavBar
            location={this.props.location}
            match={this.props.match}
          />

          {this.props.hasVideo &&   <div className="videoOverlay" >
            <h1 className="featureHeadline">811</h1>
            <h1 className="featureHeadline-sub">It's Just Three Numbers, but Could Save your life</h1>
            <img src={playButton} className="playButton" height="50px" width="50px" />
            <button type="button" ref="modalBtn" id="modalBtn" className="btn btn-info btn-lg" data-toggle="modal" data-target="#modal-video">Open Modal</button>
          </div>}

          <div className="header-title">
            <h1>{this.props.pageTitle}</h1>
          </div>
        </div>
      </div>
    );
  }
}

Header.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string,
    hash: PropTypes.string,
  }).isRequired,
  match: PropTypes.shape({
    isExact: PropTypes.bool,
    params: PropTypes.object,
    path: PropTypes.string,
    url: PropTypes.string,
  }).isRequired,
  section: PropTypes.string
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/common/header/Header.js